module.exports = __webpack_public_path__ + "img/read1.b75844c1.png";